import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useLocation } from 'react-router-dom';
import './WeeklyPopup.css';
import { usePopup } from '../../hooks/usePopup';

export default function WeeklyPopup() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const { popup, loading } = usePopup({ initialLoad: isHomePage });
  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    if (!isOpen || !popup) return;
    const { overflow } = document.documentElement.style;
    document.documentElement.style.overflow = 'hidden';

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') setIsOpen(false);
    };
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      document.documentElement.style.overflow = overflow;
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, popup]);

  const closePopup = () => {
    setIsOpen(false);
  };

  if (!isHomePage) return null;

  if (loading) return null;

  const imageUrl = popup?.imageUrl;

  if (!imageUrl || !isOpen) return null;

  const hasContent = popup.icerik && popup.icerik.trim().length > 0;
  const hasLink = !!popup.url;
  const isLinkOnly = hasLink && !hasContent;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      closePopup();
    }
  };

  return createPortal(
    <div className="weekly-popup-overlay" onClick={handleOverlayClick}>
      <div className={`weekly-popup-container ${hasContent ? 'has-content' : ''}`}>
        <button className="weekly-popup-close" onClick={closePopup}>
          ✕
        </button>
        <img
          src={imageUrl}
          alt={popup?.adi || "Duyuru"}
          className="weekly-popup-image"
          loading="eager"
        />
        {hasContent && (
          <div className="weekly-popup-content">
            <div className="weekly-popup-content-text">{popup.icerik}</div>
            {hasLink && (
              <a href={popup.url} target="_blank" rel="noopener noreferrer" className="weekly-popup-button">
                Detaylı Bilgi
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                 <path d="M5 12h14" />
                 <path d="M12 5l7 7-7 7" />
                </svg>
              </a>
            )}
          </div>
        )}
        {isLinkOnly && (
          <a href={popup.url} target="_blank" rel="noopener noreferrer" className="weekly-popup-button overlay-button">
            Detaylı Bilgi
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14" />
              <path d="M12 5l7 7-7 7" />
            </svg>
          </a>
        )}
      </div>
    </div>,
    document.body
  );
}
